import BookingsSettingsTemplate from "components/templates/SettingsTemplate/BookingSettingsTemplate"

const BookingSettings = () => (
  <BookingsSettingsTemplate />
)

export default BookingSettings